var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',[(_vm.$vuetify.breakpoint.mdAndUp)?_c('report-desktop'):_vm._e(),(_vm.$vuetify.breakpoint.smAndDown)?_c('report-mobile'):_vm._e(),_c('cash-count-dialog',{attrs:{"check-function":() => {}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }